import styled from 'styled-components';

import { fontStyles } from 'theme';

const ExternTitle = styled.h1`
  ${fontStyles.titleH3}
  margin: 40px 0 30px 0;
  @media (max-width: 991px) {
    margin-top: 20px;
  }
`;

export default ExternTitle;
